import { BackgroundInfoTopicCountry } from './background-info-topic-country';

export class BackgroundInfoTopic {
  topicId?: number;
  name: string;
  sortOrder: number;
  objectType: number;
  taxYear: number;
  country?: BackgroundInfoTopicCountry;
}
